import { cn } from "@/lib/utils";
import { X } from "lucide-react";

interface ChipProps {
  label: string;
  onRemove: () => void;
  title?: string;
  className?: string;
}

/** Chip removível para itens de multi-seleção. */
export function Chip({ label, onRemove, title, className }: ChipProps) {
  return (
    <span
      title={title ?? label}
      className={cn(
        "inline-flex max-w-full items-center gap-1 rounded-full bg-secondary py-1 pl-2.5 pr-1 text-xs text-secondary-foreground ring-1 ring-inset ring-border",
        className,
      )}
    >
      <span className="truncate">{label}</span>
      <button
        type="button"
        onClick={onRemove}
        aria-label={`Remover ${label}`}
        className="rounded-full p-0.5 text-muted-foreground transition-colors hover:bg-slate-200 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <X className="h-3 w-3" aria-hidden="true" />
      </button>
    </span>
  );
}
